<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
                <a-form-item label="moduleType" name="moduleType">
                    <a-input v-model:value="form.moduleType"/>
                </a-form-item>
                <a-form-item label="systemType" name="systemType">
                    <a-input v-model:value="form.systemType"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="12">
                    <a-form-item label="需求名称" name="needName">
                        <a-input v-model:value="form.needName" placeholder="请输入需求名称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="需求类型" name="needType">
                        <DictSelect
                            v-model:value="form.needType"
                            :dict-name="innovation.DEMAND_TYPE"
                            placeholder="请选择"
                        />
                    </a-form-item>
                </a-col>

                <!-- <a-col :span="12">
                    <a-form-item label="是否公开" name="isOpen">
                        <DictSelect
                            v-model:value="form.isOpen"
                            :dict-name="innovation.ISPUBLIC"
                            placeholder="请选择"
                        />
                    </a-form-item>
                </a-col> -->
                <a-col :span="24">
                    <a-form-item label="需求描述" name="needBody">
                        <TinymceEditor v-model:value="form.needBody"/>
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
    // import dataCheck from "@/utils/dataCheck";
    import {formMixin} from "@/mixins";
    import {demandApi} from "@/api/innovationService";
    import DictSelect from "@/components/other/DictSelect";
    import {innovation} from "@/config/variableConfig";
    import TinymceEditor from "@/components/form/editor/TinymceEditor";

    export default {
        name: "AddOrEditModal",
        components: {TinymceEditor, DictSelect},

        mixins: [formMixin],
        data() {
            return {
                innovation,
                form: {
                    id: null,
                    needName: null,
                    needType: null,
                    isOpen: null,
                    needBody: null,
                    systemType: null,
                    moduleType: null,

                },
                rules: {
                    id: [],
                    needName: [],
                    needType: [],
                    isOpen: [],
                    needBody: [],
                    systemType: [],
                    moduleType: [],
                },
                submitUrl: demandApi.saveOrUpdate
            }
        },
        mounted() {
        },
        methods: {},
    }
</script>
<style scoped lang="less">
</style>
